// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"223":"69b91521","246":"e2ef0147","255":"258d05a7","316":"929d9fb0","468":"9d4e46e6","594":"feae7195"}[chunkId] + ".js";
};